import { render, staticRenderFns } from "./ICheckbox.vue?vue&type=template&id=46e7fb28&scoped=true&"
import script from "./ICheckbox.vue?vue&type=script&lang=ts&"
export * from "./ICheckbox.vue?vue&type=script&lang=ts&"
import style0 from "./ICheckbox.vue?vue&type=style&index=0&id=46e7fb28&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46e7fb28",
  null
  
)

export default component.exports